import { useState } from 'react';

import { Trans, useLingui } from '@lingui/react/macro';

import styles from './AmountScreen.module.css';
import { useNumberFormat } from '../../../../hooks/useNumberFormat';
import { RangeSlider } from '../../RangeSlider/RangeSlider';
import { StepLayout } from '../../StepLayout/StepLayout';

const MIN_AMOUNT = 1000;
const MAX_AMOUNT = 500000;
const STEP = 1000;
const DEFAULT_AMOUNT = 25000;

// DIT-669. Local state for now — swaps to the shared RHF form store (DIT-664) once merged.
export const AmountScreen = () => {
  const { t } = useLingui();
  const { formatCurrency } = useNumberFormat();
  const [amount, setAmount] = useState(DEFAULT_AMOUNT);

  const isValidAmount = amount >= MIN_AMOUNT && amount <= MAX_AMOUNT;

  return (
    <StepLayout
      stageTitle={t`Credit request`}
      heading={t`How much would you like to borrow?`}
      ctaDisabled={!isValidAmount}
    >
      <p className={styles.amount}>{formatCurrency(amount)}</p>
      <p className={styles.note}>
        <Trans>non-binding · doesn't affect your credit score</Trans>
      </p>
      <RangeSlider
        min={MIN_AMOUNT}
        max={MAX_AMOUNT}
        step={STEP}
        value={amount}
        onChange={setAmount}
        ariaLabel={t`How much would you like to borrow?`}
        minLabel={formatCurrency(MIN_AMOUNT)}
        maxLabel={formatCurrency(MAX_AMOUNT)}
      />
    </StepLayout>
  );
};
